import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import {virtualPageView} from '@oa-shared-components/oa-fe-ga-library';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      gaPageView: '/smartsearch',
      pageView: {
        category: 'smartsearch',
        action: 'PageView',
        value: 'Home',
      },
    },
  },
  ],
});

router.beforeEach((to, from, next) => {
  // Check if we are actually changing routes and there is a google Analytics page view avalaible
  if (from.name !== to.name && to.meta.gaPageView) {
    virtualPageView(to.meta.gaPageView);
  }

  next();
});

export default router;
